import React, { useState } from "react";
import PropTypes from "prop-types";

//
import { Button, Form, Modal, Spinner } from "react-bootstrap";

//
import { Formik } from "formik";
import * as yup from "yup";

//
import { existEmail, changeEmail } from "../../../redux/features/user/actions";
import { updateEmail } from "../../../redux/features/user/slice";
import { connect } from "react-redux";

function ChangeEmailModal({ updateEmail }) {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1);

  /**
   * Hide Modal
   * clear data when modal hide
   */
  const hideModal = () => {
    setEmail("");
    setStep(1);

    setShow(false);
  };

  /**
   * Check Email Exist
   * check email exist or not before give user password
   */
  const check_exist_email = (e) => {
    // start loading
    setLoading(true);

    // request
    existEmail(e).then((res) => {
      if (res) {
        setLoading(false);

        setEmail(e.email);
        setStep(2);
      } else {
        setLoading(false);
      }
    });
  };

  /**
   * Submit password
   * send email and password for change email
   * update store user email after change
   * then close modal
   */
  const submit_password = (e) => {
    // start loading
    setLoading(true);

    // set variable
    let content = {
      email,
      password: e.password,
    };

    // request
    changeEmail(content).then((res) => {
      if (res) {
        setLoading(false);

        updateEmail(content.email);

        hideModal();
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <>
      <Button variant="info" size="sm" onClick={() => setShow(true)}>
        Change Email
      </Button>

      <Modal centered size="lg" show={show} onHide={hideModal}>
        <Modal.Header closeButton>
          <p className="step">Step {step} of 2</p>
          <h5>Change Email</h5>
          <p className="subject">
            Merge your account instagram, facebook, telegram, and twitter
          </p>
        </Modal.Header>

        <Modal.Body>
          {step === 1 ? (
            // New Email Form
            <div>
              <Formik
                validationSchema={yup.object().shape({
                  email: yup.string().email().required(),
                })}
                onSubmit={check_exist_email}
                initialValues={{
                  email,
                }}
              >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Form.Group
                      className="form-group"
                      controlId="validationFormik0"
                    >
                      <Form.Label>Input New Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Type here..."
                        className="form-control"
                        onChange={handleChange}
                        autoComplete="off"
                        value={values.email}
                        isInvalid={touched.email && !!errors.email}
                      />
                    </Form.Group>

                    <div className="actions">
                      <div className="back" onClick={hideModal}>
                        Close
                      </div>

                      <Button variant="info" size="lg" type="submit">
                        Continue
                        {loading && (
                          <div className="spinner-holder">
                            <Spinner
                              animation="border"
                              variant="white"
                              size="sm"
                            />
                          </div>
                        )}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          ) : (
            // Get User Password For Update Email
            <Formik
              validationSchema={yup.object().shape({
                password: yup.string().required(),
              })}
              onSubmit={submit_password}
              initialValues={{
                password: "",
              }}
            >
              {({ handleSubmit, handleChange, values, touched, errors }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <Form.Group
                    className="form-group"
                    controlId="validationFormik01"
                  >
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Type here..."
                      className="form-control"
                      onChange={handleChange}
                      autoComplete="off"
                      isInvalid={touched.password && !!errors.password}
                    />
                  </Form.Group>

                  <div className="actions">
                    <div className="back" onClick={() => setStep(1)}>
                      Back
                    </div>

                    <Button variant="info" type="submit" size="lg">
                      Submit
                      {loading && (
                        <div className="spinner-holder">
                          <Spinner
                            animation="border"
                            variant="white"
                            size="sm"
                          />
                        </div>
                      )}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

const mapDispatchToProps = {
  updateEmail,
};

ChangeEmailModal.propTypes = {
  updateEmail: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(ChangeEmailModal);
